import { render, staticRenderFns } from "./update-loader.vue?vue&type=template&id=77839a44"
import script from "./update-loader.vue?vue&type=script&lang=js"
export * from "./update-loader.vue?vue&type=script&lang=js"
import style0 from "./update-loader.vue?vue&type=style&index=0&id=77839a44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports